import { getConfig } from '@/config/env';

import { AuthApi } from './auth-api';
import { OrganizationApi } from './organization-api';
import { OrdersApi } from './orders-api';
import { PortalClient } from './portal-client';
import { RegistrationApi } from './registration-api';
import { UserApi } from './user-api';

export interface PortalApi {
  client: PortalClient;
  auth: AuthApi;
  registration: RegistrationApi;
  orders: OrdersApi;
  user: UserApi;
  organization: OrganizationApi;
  register: (handler: () => void) => void;
}

/** Builds a wired Portal API instance from the validated app configuration. */
export function createPortalApi(): PortalApi {
  const client = new PortalClient(getConfig());
  return {
    client,
    auth: new AuthApi(client),
    registration: new RegistrationApi(client),
    user: new UserApi(client),
    organization: new OrganizationApi(client),
    register: (handler) => client.setUnauthorizedHandler(handler),
    orders: new OrdersApi(client),
  };
}

export { AuthApi } from './auth-api';
export { OrdersApi } from './orders-api';
export { OrganizationApi } from './organization-api';
export { PortalClient } from './portal-client';
export { ReferenceApi } from './reference-api';
export { RegistrationApi } from './registration-api';
export { UserApi } from './user-api';
export { ApiError, errorKeyOf, type ApiErrorKey } from './errors';
export * from './types';
